import React, { useState, useEffect, useRef, ReactNode } from 'react';

interface AutoScrollerProps {
	children: ReactNode;
}

export default function AutoScroller({ children }: AutoScrollerProps) {
	const scrollRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const element = scrollRef.current;
		if (!element)
			return;
		const { scrollTop, clientHeight, scrollHeight } = element;
		const isAtBottom = scrollTop + clientHeight >= scrollHeight;
		if (isAtBottom)
			scrollRef.current.scrollTop = scrollHeight;
	}, [children]);

	return (
		<div ref={scrollRef} className="AutoScroller">
		{children}
		</div>
	);
}

